/** W82 Beta-W (D-637, D-658): Sätze der Welle „Beta-Rückmeldung“ wortgleich aus `satzquelle-beta-rueckmeldung.md` (Spalte W).
 *  Die Schlüssel sind die der Satzquelle; dieselbe JSON-Kopie (`tests/unit/satzquelle-beta.json`, alle Schlüssel samt iOS,
 *  Android und Server) prüfen Web, iOS und Android. Der Assistent heißt „Gaist“. Platzhalter in `{}`. */
export const BETA_SAETZE = {
  "rueckmeldung.menue": "Rückmeldung geben",
  "beta.zeichen": "Beta",
  "beta.zeichen.name": "Beta, Rückmeldung geben",
  "rueckmeldung.titel": "Rückmeldung geben",
  "rueckmeldung.einleitung":
    "Was ist dir aufgefallen? Was hakt, was fehlt, was gefällt dir?",
  "rueckmeldung.feld": "Deine Rückmeldung",
  "rueckmeldung.feld.rest": "Noch {rest} Zeichen",
  "rueckmeldung.feld.voll": "Mehr passt nicht hinein.",
  "rueckmeldung.bild.knopf": "Bildschirmfoto anhängen",
  "rueckmeldung.bild.warnung": "Ein Bildschirmfoto kann Briefinhalt zeigen.",
  "rueckmeldung.bild.weg.web":
    "Die Web-App kann selbst kein Bildschirmfoto machen. Mach es mit deinem Gerät und wähle es hier aus.",
  "rueckmeldung.bild.gewaehlt": "Bildschirmfoto angehängt",
  "rueckmeldung.bild.name": "Angehängtes Bildschirmfoto",
  "rueckmeldung.bild.entfernen": "Entfernen",
  "rueckmeldung.angaben.web":
    "Mitgeschickt werden die Version der App, die Ansicht, in der du warst, und deine Darstellung. Browser und System erkennt unser Server.",
  "rueckmeldung.senden": "Senden",
  "rueckmeldung.laeuft": "Wird gesendet …",
  "rueckmeldung.abbrechen": "Abbrechen",
  "rueckmeldung.danke.gaist":
    "Danke! Deine Rückmeldung ist bei uns angekommen.",
  "rueckmeldung.danke.still": "Rückmeldung gesendet.",
  "rueckmeldung.fehler.leer": "Schreib bitte ein paar Worte.",
  "rueckmeldung.fehler.gross": "Das Bild ist größer als 5\u00a0MB.",
  "rueckmeldung.fehler.unlesbar":
    "Dieses Bild lässt sich nicht lesen. Bitte wähle ein anderes.",
  "rueckmeldung.fehler.viele":
    "Du hast gerade viele Rückmeldungen geschickt. Bitte versuch es später noch einmal.",
  "fehler.netz": "Keine Verbindung. Bitte später noch einmal.",
  "fehler.eingaben": "Bitte die Eingaben prüfen.",
  "betrieb.rm.zeile": {
    zeile: "Rückmeldungen",
    unterzeile: "Was Tester schreiben, mit Bildschirmfoto",
  },
  "betrieb.rm.titel": {
    titel: "Rückmeldungen",
    offen: "Offen",
    erledigt: "Erledigt",
  },
  "betrieb.rm.hinweis":
    "Rückmeldungen können Briefinhalt zeigen. Nur dein Betreiberkonto sieht sie hier.",
  "betrieb.rm.leer": {
    offen: "Keine offenen Rückmeldungen",
    erledigt: "Nichts erledigt in den letzten 30 Tagen",
  },
  "betrieb.rm.listenzeile": {
    zeile: "{datum} · {plattform} {version} · {kennung}",
    bild: "mit Bildschirmfoto",
    // W82 Beta-W2 (RM54, RM55; Vertrag Beta-S2 Abschnitt 10): Merkmale, wenn `brief` beziehungsweise `gemeinsam` wahr ist
    brief: "aus einem Brief",
    gemeinsam: "gemeinsam",
  },
  "betrieb.rm.ohne.kennung": "ohne Beta-Kennung",
  "betrieb.rm.felder": {
    eingang: "Eingang",
    erledigt: "Erledigt",
    plattform: "Plattform",
    version: "Version",
    geraet: "Gerät",
    ansicht: "Ansicht",
    darstellung: "Darstellung",
    haushalt: "Haushalt",
    bild: "Bildschirmfoto",
  },
  "betrieb.rm.erledigen": {
    knopf: "Erledigt",
    titel: "Als erledigt markieren?",
    text: "Das Bildschirmfoto wird gelöscht. Den Text siehst du noch 30 Tage unter „Erledigt“.",
    behalten: "Behalten",
    handlung: "Erledigt",
  },
  "betrieb.rm.loeschen": {
    knopf: "Löschen",
    titel: "Rückmeldung löschen?",
    text: "Text und Bildschirmfoto werden sofort gelöscht.",
    behalten: "Behalten",
    handlung: "Löschen",
  },
  "betrieb.rm.erledigt": "Erledigt. Bildschirmfoto gelöscht.",
  "betrieb.rm.geloescht": "Gelöscht.",
  "betrieb.rm.bild.fehlt": "Das Bildschirmfoto lässt sich nicht laden.",
  "betrieb.rm.bild.name": "Bildschirmfoto zur Rückmeldung vom {datum}",
  "betrieb.funktion": {
    anfrage: "POST /api/rueckmeldungen",
    name: "Rückmeldung gesendet",
  },
  "beta.begruessung.titel": "Willkommen in der Beta",
  "beta.begruessung.text.1":
    "Schön, dass du Papiergaist ausprobierst. Was dir auffällt, hilft uns: was hakt, was fehlt, was dir gefällt.",
  "beta.begruessung.text.2":
    "Schreib uns über „Rückmeldung geben“ im Profil-Menü oder über „Beta“ unten in der Leiste. Ein Bildschirmfoto kannst du anhängen.",
  "beta.begruessung.text.3":
    "Rückmeldungen speichern wir bei deinem Haushalt und löschen sie, sobald wir sie bearbeitet haben.",
  "beta.begruessung.knopf": "Verstanden",
} as const;

export const RM = BETA_SAETZE;

/** Platzhalter `{name}` füllen. */
export function satz(
  vorlage: string,
  werte: Record<string, string | number>,
): string {
  return vorlage.replace(/\{(\w+)\}/g, (ganz, name: string) =>
    name in werte ? String(werte[name]) : ganz,
  );
}
